import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/list',
      method: 'get',
      params: params
    })
  },

  allItemList: function (params) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/allItemList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmsetmealpositionprojectitem/cecUnmSetMealPositionProjectItem/import',
      method: 'post',
      data: data
    })
  }
}
